import { AxiosResponse } from "axios";
import { API_ENDPOINTS } from "../../../constants/api_endpoints";
import axios from "../../../lib/axios";
import { QData } from "../../../types/basic-type-list";
import { IDeleteDataResponseAndPayload, TResponse, TResponseWithQData } from "../../../types/common";
import { IJob, IJobCreatePayload, IJobUpdatePayload } from "../../../types/api/job";

export async function listJob(
  qData: QData
): Promise<AxiosResponse<TResponseWithQData<IJob[]>>> {
  return axios.get(API_ENDPOINTS.JOB_LIST, { params: qData });
}

export async function jobDetails(
  id: string | number
): Promise<AxiosResponse<TResponse<IJob>>> {
  return axios.get(`${API_ENDPOINTS.JOB_DETAILS}/${id}`);
}

export async function createJob(
  data: IJobCreatePayload
): Promise<AxiosResponse<TResponse<IJob>>> {
  return axios.post<TResponse<IJob>>(API_ENDPOINTS.JOB_CREATE, data);
}

export async function updateJob(
  data: IJobUpdatePayload
): Promise<AxiosResponse<TResponse<IJob>>> {
  return axios.post<TResponse<IJob>>(API_ENDPOINTS.JOB_UPDATE, data);
}

export async function deleteJob(
  data: IDeleteDataResponseAndPayload
): Promise<AxiosResponse<TResponse<IDeleteDataResponseAndPayload>>> {
  return axios.post<TResponse<IDeleteDataResponseAndPayload>>(API_ENDPOINTS.JOB_DELETE, data);
}

// legacy alias
export async function saveJob(
  data: IJobCreatePayload & { id?: number }
): Promise<AxiosResponse<TResponse<IJob>>> {
  if (data.id) {
    return updateJob(data as IJobUpdatePayload);
  }
  return createJob(data);
}
